import application from 'application/application';

application
	/* eslint-disable */
	.directive('submenu', [
		'$rootScope',
		'$state',
		'$http',
		'authentication',
		'helper',
		'API',
		($rootScope, $state, $http, authentication, helper, API) => {
			/* eslint-enable */
			$rootScope.printingFinances = false;

			$rootScope.stateGoFinances = params => {
				if ($rootScope.printingFinances == false) $state.go(params);
			};

			setInterval(() => {
				if (
					$state.params.filtro === undefined ||
					$state.params.filtro === 'vencendo'
				) {
					$state.params.filtro = 'vencendo';
					if (!!document.getElementById('A vencer'))
						document.getElementById('A vencer').classList.add('active');
				}
			}, 200);

			return {
				scope: {
					submenu: '@',
					customClick: '='
				},
				template: /*html*/ `
				<div class="submenu">
					<div class="position-fixed bgc-gray">
						<div class="submenu-title d-flex align-items-center justify-content-between">
							<span>{{title}}</span>
							<button ng-if="addButton && !addButton[0].tooltip" type="button"
							data-toggle="modal" data-target="{{addButton[0].target}}" ng-click="customClick()"
							class="submenu-subtitle-btn btn-icon">
								<i class="nav-icons-icon material-icons color-green-add-circle" aria-hidden="true">add_circle</i>

								<span class="sr-only">{{addButton[0].name}}</span>
							</button>
							<button ng-if="addButton && addButton[0].tooltip" type="button" class="submenu-subtitle-btn btn-icon"
								data-container="body" data-toggle="popover"
								data-template="{{addButton[0].template}}"
								data-html="true" data-trigger="focus" data-content="{{addButton[0].options}}" data-placement="bottom">
								<i class="nav-icons-icon material-icons medium-emphasis-color" aria-hidden="true">add_circle</i>
								<span ng-if="!addButton[0].tooltip" class="sr-only">{{addButton[0].name}}</span>
							</button>
							<div ng-if="exitButton" class="float-right"> <button type="button" class="btn btn-link btn-link-danger lh-1 p-0 font-weight-bold" ng-click="signOut()">Sair</button> </div>
						</div>
						<ul class="nav flex-column">
							<li class="nav-item" ng-if="links" ng-repeat="link in links">
								<div ng-if="link.subtitle" class="submenu-subtitle d-flex align-items-center justify-content-between">
									{{link.name}}
									<button ng-if="link.target" class="submenu-subtitle-btn ml-2" type="button" data-toggle="modal" data-target="{{link.target}}">
										<i class="submenu-title-icon material-icons" aria-hidden="true">search</i>
									</button>
								</div>
								<span ng-if="hasCounters && !link.subtitle && !link.filter">
									<a class="nav-link" ui-sref="{{link.sref}}" ui-sref-opts="{{link.srefOpt}}" ui-sref-active="{{link.active}}">
										<div class="row m-0 align-items-center justify-content-between">
											{{link.name}}
											<span ng-if="link.filter && link.filter == key" ng-repeat="(key, counter) in counters">
												<p class="m-0 font-xs" ng-if="link.filter == key" ng-class="{ fadeIn: key }"><b>{{counter}}</b></p>
											</span>
											<span ng-if="!link.filter && link.counter">
												<p class="m-0 font-xs" ng-class="{ fadeIn: link.counter }"><b>{{link.counter}}</b></p>
											</span>
										</div>
									</a>
								</span>
								<span ng-if="hasCounters && !link.subtitle && link.filter">
									<a id="{{ link.name }}" class="nav-link" ui-sref="{{link.sref}}" ui-sref-opts="{{link.srefOpt}}" ng-class="{ 'active': activeItem === link.filter}" ui-sref-active="{{link.active}}">
										<div class="row m-0 align-items-center justify-content-between">
											{{link.name}}
											<span ng-if="link.filter && link.filter == key" ng-repeat="(key, counter) in counters">
												<p class="m-0 font-xs" ng-if="link.filter == key" ng-class="{ fadeIn: key }"><b>{{counter}}</b></p>
											</span>
											<span ng-if="!link.filter && link.counter">
												<p class="m-0 font-xs" ng-class="{ fadeIn: link.counter }"><b>{{link.counter}}</b></p>
											</span>
										</div>
									</a>
								</span>
								<ul ng-if="link.subLinks && keyWordsMovements.isReady() && keyWordsMovements.hasItems() && link.filter == 'keywords'" class="nav flex-column mb-4">
									<li class="nav-item" ng-repeat="item in keyWordsMovements | orderBy: 'palavraChave' | orderBy:'!totalNaoLidas'" id="keyWordsFolder-{{item.id}}">
										<a class="nav-link" title="{{item.palavraChave}}" ui-sref="root.default.movements.list3({ pasta: item.id })" ui-sref-opts="{{link.srefOpt}}" ui-sref-active="{{link.active}}" ng-if="item.situacaoPalavraChave">

											<div class="row m-0 align-items-center justify-content-between">
												<span class="nav-text" ng-class="{ 'nav-text-with-counter' : item.totalNaoLidas }" ng-bind="item.palavraChave">{{item.palavraChave}}</span>
												<p class="mb-0 font-xs nav-counter"><b>{{item.totalNaoLidas || ''}}</b></p>
											</div>
										</a>
									</li>
								</ul>
								<ul class="nav flex-column mb-4" ng-if="link.subLinks && processMovements && link.filter == 'process'">
									<li class="nav-item" ng-repeat="item in processMovements.getItems() | orderBy:'nome' | orderBy:'!totalNaoLidas'" id="processWordsFolder-{{item.id}}">
										<a class="nav-link" title="{{item.nome}}" ui-sref="root.default.movements.list4({ pasta: item.id})" ui-sref-opts="{{link.srefOpt}}" ui-sref-active="{{link.active}}">
											<div class="row m-0 align-items-center justify-content-between">
												<span class="nav-text" ng-class="{ 'nav-text-with-counter' : item.totalNaoLidas }">{{item.nome | formatToCNJ}}</span>
												<p class="mb-0 font-xs nav-counter"><b>{{item.totalNaoLidas || ''}}</b></p>
											</div>
										</a>
									</li>
								</ul>

								<div class="submenu-loading mb-4" ng-if="keyWordsMovements.isNotReady()">
									Carregando...
								</div>
								<span ng-if="link.sref && !hasCounters && link.url != 'integrations' && link.url != 'group'">
									<a class="nav-link pointer" ui-sref-opts="{{link.srefOpt}}" ui-sref-active="{{link.active}}" id="{{link.url}}" ng-click="stateGoFinances(link.sref, link.url)">{{link.name}}</a>
								</span>
								<span ng-if="link.sref && !hasCounters && link.url == 'integrations' && hasIntegration">
									<a class="nav-link" ui-sref="{{link.sref}}" ui-sref-active="{{link.active}}" id="{{link.id || ''}}" >{{link.name}}</a>
								</span>
								<span ng-if="link.sref && !hasCounters && link.url == 'group' && hasGroup">
									<a class="nav-link" ui-sref="{{link.sref}}" ui-sref-active="{{link.active}}" id="{{link.id || ''}}" >{{link.name}}</a>
								</span>
								<span ng-if="!link.sref && !hasCounters && link.url != 'integrations' && link.url != 'group'">
									<a class="nav-link" href="{{link.href}}" ui-sref-opts="{{link.srefOpt}}" ui-sref-active="{{link.active}}" target="_blank" id="{{link.id || ''}}" >{{link.name}}</a>
								</span>
								<span ng-if="!link.sref && !hasCounters && link.url == 'integrations' && hasIntegration">
									<a class="nav-link" href="{{link.href}}" ui-sref-active="{{link.active}}" target="_blank" id="{{link.id || ''}}" >{{link.name}}</a>
								</span>
								<span ng-if="!link.sref && !hasCounters && link.url == 'group' && hasGroup">
									<a class="nav-link" href="{{link.href}}" ui-sref-active="{{link.active}}" target="_blank" id="{{link.id || ''}}" >{{link.name}}</a>
								</span>
							</li>
						</ul>
					</div>
				</div>
			`,
				replace: true,
				link: (scope, element, attrs) => {
					scope.$parent.$watch(attrs.ngModel, () => {
						let options;

						if (attrs.submenu) {
							options = JSON.parse(attrs.submenu);

							if (options['hasCounters'])
								scope.hasCounters = options['hasCounters'];

							if (options['title']) scope.title = options['title'];

							if (options['exitButton'])
								scope.exitButton = options['exitButton'];

							if (options['links']) scope.links = options['links'];

							if (options['keyWordsMovements'])
								scope.keyWordsMovements = options['keyWordsMovements'];

							if (options['processMovements'])
								scope.processMovements = options['processMovements'];

							if (options['counters']) scope.counters = options['counters'];

							if (options['activeItem'])
								scope.activeItem = options['activeItem'];

							if (options['addButton']) scope.addButton = options['addButton'];
						}

						if (scope.addButton) {
							if (
								scope.addButton[0]['target'] &&
								scope.addButton[0]['onClick']
							) {
								$(scope.addButton[0]['target']).on(
									'shown.bs.modal',
									function() {
										const clickFunction = eval(
											'(' + scope.addButton[0].onClick + ')'
										);

										clickFunction();
									}
								);
							}
						}

						setInterval(() => {
							if (window.location.pathname === '/financeiro/fluxo-de-caixa') {
								document.getElementById('flow').classList.add('active');
								document.getElementById('releases').classList.remove('active');
								document
									.getElementById('categories')
									.classList.remove('active');
							}

							if (window.location.pathname === '/financeiro/lancamentos') {
								document.getElementById('releases').classList.add('active');
								document.getElementById('flow').classList.remove('active');
								document
									.getElementById('categories')
									.classList.remove('active');
							}

							if (window.location.pathname === '/financeiro/categorias') {
								document.getElementById('categories').classList.add('active');
								document.getElementById('releases').classList.remove('active');
								document.getElementById('flow').classList.remove('active');
							}
						}, 200);

						// scope.recordFlagHasGroup = async() => {
						// 	$http({
						// 		...helper.http(API.customers, 'GET'),
						// 		params: {
						// 			...helper.httpFields([
						// 				'possuiGrupo'
						// 			]),
						// 			IDs: JSON.parse(localStorage.getItem('__authenticationUserData__')).idCliente
						// 		}
						// 	})

						// 		.then(response => {
						// 			if (response.data.itens[0].possuiGrupo) {
						// 				$http({
						// 					...helper.http(API.groupUsers, 'GET'),
						// 					params: {
						// 						...helper.httpFields([
						// 							'ListaUsuariosGrupo.IdUsuarioXGrupo, ListaUsuariosGrupo.IdUsuarioCliente, ListaUsuariosGrupo.administrador'
						// 						]),
						// 						IdsSituacaoGrupoUsuario: [-1, -2],
						// 						paginaAtual: 1,
						// 						registrosPorPagina: 1
						// 					}
						// 				})
						// 					.then(res => {
						// 						let usersList = res.data.itens[0] && res.data.itens[0].listaUsuariosGrupo || [];

						// 						let adminList = usersList.filter(user => user.idUsuarioCliente == JSON.parse(localStorage.getItem('__authenticationUserData__')).idUsuarioCliente && user.administrador);

						// 						$http({
						// 							...helper.http(API.usersCustomers, 'GET'),
						// 							params: {
						// 								...helper.httpFields([
						// 									'usuarioAdministrador'
						// 								]),
						// 								IDs: JSON.parse(localStorage.getItem('__authenticationUserData__')).idUsuarioCliente
						// 							}
						// 						})
						// 							.then(res => {
						// 								scope.isUserAdmin = res.data.itens[0].usuarioAdministrador;

						// 							})
						// 							.finally(() => {
						// 								scope.hasGroup = adminList.length > 0 || scope.isUserAdmin;
						// 							});

						// 					});
						// 			} else {
						// 				scope.hasGroup = false;
						// 			}

						// 		});
						// };

						// scope.recordFlagHasGroup();
					});
					scope.stateGoFinances = (params, url) => {
						$rootScope.stateGoFinances(params);

						if (url == 'releases') {
							let idReleases = document.getElementById('releases');

							idReleases.className = 'nav-link pointer ng-binding active';

							let idFlow = document.getElementById('flow');

							idFlow.className = 'nav-link pointer ng-binding';

							let idCategories = document.getElementById('categories');

							idCategories.className = 'nav-link pointer ng-binding';
						}
						if (url == 'flow') {
							let idReleases = document.getElementById('releases');

							idReleases.className = 'nav-link pointer ng-binding';

							let idFlow = document.getElementById('flow');

							idFlow.className = 'nav-link pointer ng-binding active';

							let idCategories = document.getElementById('categories');

							idCategories.className = 'nav-link pointer ng-binding';
						}
						if (url == 'categories') {
							let idReleases = document.getElementById('releases');

							idReleases.className = 'nav-link pointer ng-binding';

							let idFlow = document.getElementById('flow');

							idFlow.className = 'nav-link pointer ng-binding';

							let idCategories = document.getElementById('categories');

							idCategories.className = 'nav-link pointer ng-binding active';
						}
					};
				}
			};
		}
	]);
